import { enableProdMode, NgModuleRef } from '@angular/core';
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static';

// We use jquery-ui mainly for the ui-sortable lib (used to allow dragging widgets on the dashboard)
// and the angular-ui lib (the ui-mask directive relies on jquery-ui)
// import 'jqueryui/jquery-ui'; // If we upgrade to install a newer version as jquery-ui (not jqueryui) we can remove the folder here
// It's unclear if this actually works and if it's required to also include in scripts in .angular-cli.json

import * as angular from 'angular';

setAngularJSGlobal(angular);
// import { UpgradeModule } from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
// import { AppModuleNgFactory } from './app/app.module.ngfactory';
// import { AppModuleNgFactory } from '../dist/out-tsc/ngapp/src/app/app.module.ngfactory';
import { environment } from './environments/environment';

// tslint:disable-next-line:no-import-side-effect
import './file.imports';
// tslint:disable-next-line:no-import-side-effect
import './app/hybrid/downgraded-providers';
// tslint:disable-next-line:no-import-side-effect
import 'codemirror/mode/javascript/javascript';
// tslint:disable-next-line:no-import-side-effect
import 'codemirror/mode/markdown/markdown';

if (environment.production) {
    enableProdMode();
}

console.log('domain', document.domain);
if (document.domain !== 'localhost') {
   if (window.self === window.top) {
      document.domain = 'autoremind.us';
      console.log('window.location.hostname', window.location.hostname);
   }
}

/**
 * Whenever an "upgraded"/"downgraded" component is instantiated the host element is owned by the framework doing the instantiation.
 * The other framework then instantiates and owns the view for that component.
 * a) This implies that the component bindings will always follow the semantics of the instantiation framework.
 * b) The DOM attributes are parsed by the framework that owns the current template.
 *    So attributes in Angular templates must use kebab-case, while angularJS templates must use camelCase.
 * c) However the template binding syntax will always use the Angular style, e.g. square brackets ([...]) for property binding.
 *
 * Angular is bootstrapped first; AngularJS is bootstrapped second. AngularJS always owns the root component of the application.
 * The new application is running in an Angular zone, and therefore it no longer needs calls to $apply().
 */

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((platformRef: NgModuleRef<AppModule>) => {

        // Once Angular bootstrap is complete then we bootstrap the AngularJS module

        const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
        upgrade.bootstrap(document.body, ['autoremind'], {strictDi: true}
         );

        const appModule: AppModule = platformRef.instance;
        // Now the angularJS injector is available to upgrade angularJS services and inject into Angular modules/services
        appModule.afterJSBootstrap();
})
    .catch(err => console.log(err));
